module.exports = __webpack_public_path__ + "img/4.5.COD.d4f5576a.png";